// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload {
   background-color: #fff;
   border: 1px solid #ccc;
   border-radius: 4px;
   position: fixed;
   right: 0;
   bottom: 0;
   width: 450px;
   z-index: 999;
}
.upload .title {
   background-color: #555;
   color: #fff;
   padding: 8px 50px 8px 10px;
   position: relative;
}
.upload ul {
   list-style: none;
   margin: 0;
   padding: 0;
}
.upload li {
   border-bottom: 1px solid #e5e5e5;
   font-size: 13px;
   padding: 10px;
}
.upload img {
   width: 24px;
   height: 24px;
   margin-right: 10px;
}
.upload .percent {
   font-size: 10px;
   opacity: .7;
   white-space: nowrap;
}
.upload .progress-bar {
   background-color: #f1f1f1;
   border-radius: 4px;
   height: 3px;
}
.upload .progress {
   background-color: #FFA726;
   height: 3px;
   width: 0;
   transition: width 1s;
}
.collapse {
   cursor: pointer;
   position: absolute;
   top: 5px;
   right: 10px;
   transition: transform .4s;
}
.flip {
   transform: rotate(180deg);
}
.wrapper {
   max-height: 60vh;
   overflow-y: auto;
}
.hide {
   display: none;
}
.option {
   display: none;
}
.done {
   display: none;
}
li:hover .option{
   cursor: pointer;
   display: block;
}
mat-icon {
   font-size: 18px;
   vertical-align: middle;
   padding: 5px 0 0 5px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/upload-progress/upload-progress.component.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,eAAe;GACf,QAAQ;GACR,SAAS;GACT,YAAY;GACZ,YAAY;AACf;AACA;GACG,sBAAsB;GACtB,WAAW;GACX,0BAA0B;GAC1B,kBAAkB;AACrB;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,gCAAgC;GAChC,eAAe;GACf,aAAa;AAChB;AACA;GACG,WAAW;GACX,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,eAAe;GACf,WAAW;GACX,mBAAmB;AACtB;AACA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,WAAW;AACd;AACA;GACG,yBAAyB;GACzB,WAAW;GACX,QAAQ;GACR,oBAAoB;AACvB;AACA;GACG,eAAe;GACf,kBAAkB;GAClB,QAAQ;GACR,WAAW;GACX,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,gBAAgB;GAChB,gBAAgB;AACnB;AACA;GACG,aAAa;AAChB;AACA;GACG,aAAa;AAChB;AACA;GACG,aAAa;AAChB;AACA;GACG,eAAe;GACf,cAAc;AACjB;AACA;GACG,eAAe;GACf,sBAAsB;GACtB,oBAAoB;AACvB","sourcesContent":[".upload {\n   background-color: #fff;\n   border: 1px solid #ccc;\n   border-radius: 4px;\n   position: fixed;\n   right: 0;\n   bottom: 0;\n   width: 450px;\n   z-index: 999;\n}\n.upload .title {\n   background-color: #555;\n   color: #fff;\n   padding: 8px 50px 8px 10px;\n   position: relative;\n}\n.upload ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.upload li {\n   border-bottom: 1px solid #e5e5e5;\n   font-size: 13px;\n   padding: 10px;\n}\n.upload img {\n   width: 24px;\n   height: 24px;\n   margin-right: 10px;\n}\n.upload .percent {\n   font-size: 10px;\n   opacity: .7;\n   white-space: nowrap;\n}\n.upload .progress-bar {\n   background-color: #f1f1f1;\n   border-radius: 4px;\n   height: 3px;\n}\n.upload .progress {\n   background-color: #FFA726;\n   height: 3px;\n   width: 0;\n   transition: width 1s;\n}\n.collapse {\n   cursor: pointer;\n   position: absolute;\n   top: 5px;\n   right: 10px;\n   transition: transform .4s;\n}\n.flip {\n   transform: rotate(180deg);\n}\n.wrapper {\n   max-height: 60vh;\n   overflow-y: auto;\n}\n.hide {\n   display: none;\n}\n.option {\n   display: none;\n}\n.done {\n   display: none;\n}\nli:hover .option{\n   cursor: pointer;\n   display: block;\n}\nmat-icon {\n   font-size: 18px;\n   vertical-align: middle;\n   padding: 5px 0 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
